import React, { useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { FAQ_FR, FAQ_EN } from '@/data/siteData';
import { ChevronDown } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-stone-200 last:border-0">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between py-5 text-left"
        data-testid={`faq-item-${question.slice(0, 20).replace(/\s/g, '-')}`}
      >
        <span className="font-semibold text-[#1a365d] pr-8">{question}</span>
        <ChevronDown 
          className={`w-5 h-5 text-[#D4AF37] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-5' : 'max-h-0'}`}
      >
        <p className="text-slate-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const { lang, t } = useLanguage();
  const faqs = lang === 'en' ? FAQ_EN : FAQ_FR;
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-[#D4AF37] font-semibold text-sm tracking-widest uppercase mb-4">
            FAQ
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1a365d] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {t('Questions Fréquentes', 'Frequently Asked Questions')}
          </h2>
          <p className="text-slate-600 text-lg">
            {t(
              'Tout ce que vous devez savoir sur nos services',
              'Everything you need to know about our services'
            )}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#D4AF37] to-[#C9A227] mx-auto mt-6 rounded-full" />
        </div>

        {/* FAQ List */}
        <div className="bg-white rounded-2xl shadow-sm border border-stone-100 p-6 lg:p-8">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => toggleFAQ(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
